import { gql } from "@apollo/client";

export const FORCE_SIGN_OUT = gql`
  mutation adminForceSignOut($userId: String!) {
    adminForceSignOut(userId: $userId) {
      status
    }
  }
`;

export const ADMIN_SECURITY_EVENTS = gql`
  query adminSecurityEvents($userId: String!, $limit: Int) {
    adminSecurityEvents(userId: $userId, limit: $limit) {
      id
      type
      ipAddress
      userAgent
      createdAt
    }
  }
`;
